export default class Constants {
    static DRAWING_THUMB_SIZE = 700;
    static FILE_THUMB_SIZE = 160;
    static PHOTO_SIZE = 160;
    static ROOT_DRAWINGS_FOLDER_ID = 'drawings';
    static ROOT_SPECIFICATIONS_FOLDER_ID = 'specifications';
    static ROOT_SCRAPBOOKS_FOLDER_ID = 'scrapbooks';
    static ROOT_TRASH_FOLDER_ID = 'trash';
    static ROOT_CONTRACTS_FOLDER_ID = 'contracts';
    static ROOT_FOLDERS = [
        this.ROOT_DRAWINGS_FOLDER_ID,
        this.ROOT_SPECIFICATIONS_FOLDER_ID,
        this.ROOT_SCRAPBOOKS_FOLDER_ID,
        this.ROOT_CONTRACTS_FOLDER_ID,
    ];
    static SUBMITTAL_CREATE_STATUS_ID = 'create';
    static SUBMITTAL_SUBMIT_STATUS_ID = 'submit';
    static SUBMITTAL_APPROVAL_STATUS_ID = 'approve';
}
